module.exports = "<symbol id=\"tt-icon-vote-on\" viewBox=\"0 0 24 24\"><path d=\"M13.71 4.32c2.92 4.52 10 14 10 14a2.35 2.35 0 0 1-2.33 2.33H2.62A2.34 2.34 0 0 1 .29 18.3s6.81-9.48 10.29-14A1.8 1.8 0 0 1 13 3.64a1.82 1.82 0 0 1 .71.68z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/search-page/vote-on.svg
// module id = 446
// module chunks = 11